import { req } from '../../@api/request';

export default class ExpectItemService {
  static list = async (
    court: string,
    belong: string,
    caseno: string,
    region: string,
    status: string,
    case_nm: string,
    owner: string,
    debtor: string,
    creditor: string,
    sort: string,
    limit: number,
    offset: number,
  ) => {
    const result = await req.get(
      `/ex/list?court=${court}&belong=${belong}&caseno=${caseno}&region=${region}&status=${status}&case_nm=${case_nm}&owner=${owner}&debtor=${debtor}&creditor=${creditor}&sort=${sort}&limit=${limit}&offset=${offset}`,
    );
    return result.data;
  };

  static basicInfo = async (t_idx: string) => {
    const result = await req.get(`/ex/detail?t_idx=${t_idx}`);
    return result.data;
  };

  static Price = async (t_idx: string) => {
    const result = await req.get(`/ex/detail/price?t_idx=${t_idx}`);
    return result.data;
  };
  static RealDeal = async (
    t_idx: string,
    distance: number,
    limit: number,
    offset: number,
  ) => {
    const result = await req.get(
      `/ex/realdeal?t_idx=${t_idx}&distance=${distance}&limit=${limit}&offset=${offset}`,
    );
    return result.data;
  };
  static ArroundRealDeal = async (
    t_idx: string,
    distance: number,
    limit: number,
    offset: number,
  ) => {
    const result = await req.get(
      `/ex/arroundRealdeal?t_idx=${t_idx}&distance=${distance}&limit=${limit}&offset=${offset}`,
    );
    return result.data;
  };
  static ArroundItem = async (t_idx: string) => {
    const result = await req.get(`/ex/detail/arround?t_idx=${t_idx}`);
    return result.data;
  };
}
